import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import * as Sentry from "@sentry/react";
import { isIE, isLegacyEdge } from "react-device-detect";
import ReactDOM from "react-dom";

import App from "./App";
import Unsupported from "./Unsupported";
import * as serviceWorker from "./serviceWorker";

Sentry.init({
  dsn: "https://78d7e9d5c755485b908d482403dd683c@o154529.ingest.sentry.io/1209388",
});

ReactDOM.render(
  isIE || isLegacyEdge ? <Unsupported /> : <App />,
  document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
